import React from "react";
import { Checkbox, Segment } from "semantic-ui-react";
import featureFlags, { categories } from "../../../utilities/featureFlags";

const FeatureFlags = ({ entity, onChange }) => {
    return (
        <div className={"mt-3"}>
            <h2>App feature flags</h2>
            <p>
                Use this section to enable or disable features within the app
                for members belonging to {entity.name}.
            </p>
            {categories.map((category) => {
                const items = featureFlags.filter(
                    (flag) => flag.category === category,
                );
                if (items.length === 0) return null;
                return (
                    <>
                        <h3>{category}</h3>
                        {items.map((flag, index) => {
                            const on = entity.featureFlags.includes(flag.key);
                            return (
                                <Segment key={index} vertical>
                                    <h4>{flag.name}</h4>
                                    <p>{flag.description}</p>
                                    <Checkbox
                                        className='mt-3'
                                        toggle
                                        label={on ? "Disabled" : "Enabled"}
                                        checked={on === false}
                                        onChange={() => onChange(flag.key)}
                                    />
                                </Segment>
                            );
                        })}
                    </>
                );
            })}
        </div>
    );
};

export default FeatureFlags;
